import { Heading, Text } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import { useEffect, useState } from "react";

function Header({ columnChartData }) {
  const [period, setPeriod] = useState("day");
  const [adjective, setAdjective] = useState("most");
  const [date, setDate] = useState();
  const [count, setCount] = useState();
  const [average, setAverage] = useState();

  const {
    maxYearArr,
    minYearArr,
    maxMonthArr,
    minMonthArr,
    maxDayArr,
    minDayArr,
    missingDates,
  } = columnChartData;

  useEffect(() => {
    const setStats = (period, adjective) => {
      if (period === "day" && adjective === "most") {
        setDate(maxDayArr[0]);
        setCount(maxDayArr[1]);
      }
      if (period === "day" && adjective === "least") {
        setDate("");
        setCount(minDayArr[1]);
      }
      if (period === "month" && adjective === "most") {
        setDate(maxMonthArr[0]);
        setCount(maxMonthArr[1]);
        setAverage(maxMonthArr[2]);
      }
      if (period === "month" && adjective === "least") {
        setDate(minMonthArr[0]);
        setCount(minMonthArr[1]);
        setAverage(minMonthArr[2]);
      }
      if (period === "year" && adjective === "most") {
        setDate(maxYearArr[0]);
        setCount(maxYearArr[1]);
        setAverage(maxYearArr[2]);
      }
      if (period === "year" && adjective === "least") {
        setDate(minYearArr[0]);
        setCount(minYearArr[1]);
        setAverage(minYearArr[2]);
      }
    };

    setStats(period, adjective);
  }, [
    period,
    adjective,
    maxDayArr,
    maxMonthArr,
    maxYearArr,
    minMonthArr,
    minYearArr,
    minDayArr,
    missingDates.length,
  ]);

  const renderPhrase = () => {
    if (period === "day" && adjective === "most") {
      return (
        <Heading mb={"3"} textAlign="center" fontWeight="thin">
          <Text
            bgGradient="linear(to-t, #12c2e9,#c471ed,#f64f59)"
            bgClip="text"
            fontSize="5xl"
            fontWeight="extrabold"
            display="inline"
          >
            {count}{" "}
          </Text>{" "}
          - That's a lot of Videos 👀
        </Heading>
      );
    } else if (period === "day" && adjective === "least") {
      if (missingDates.length !== 0) {
        return (
          <Heading mb={"3"} textAlign="center" fontWeight="thin">
            You have{" "}
            <Text
              bgGradient="linear(to-t, #12c2e9,#c471ed,#f64f59)"
              bgClip="text"
              fontSize="5xl"
              fontWeight="extrabold"
              display="inline"
            >
              {missingDates.length}{" "}
            </Text>
            Days without any Video watched 😮
          </Heading>
        );
      } else {
        return (
          <Heading mb={"3"} textAlign="center" fontWeight="thin">
            You never watched less than{" "}
            <Text
              bgGradient="linear(to-t, #12c2e9,#c471ed,#f64f59)"
              bgClip="text"
              fontSize="6xl"
              fontWeight="extrabold"
              display="inline"
            >
              {count}
            </Text>{" "}
            Videos a day 👀
          </Heading>
        );
      }
    } else {
      return (
        <Heading mb={"3"} textAlign="center" fontWeight="thin">
          <Text
            bgGradient="linear(to-t, #12c2e9,#c471ed,#f64f59)"
            bgClip="text"
            fontSize="5xl"
            fontWeight="extrabold"
            display="inline"
          >
            {count}
          </Text>{" "}
          - That's an average of{" "}
          <Text fontWeight="bold" display="inline">
            {average}
          </Text>{" "}
          Videos per day 👀
        </Heading>
      );
    }
  };

  return (
    <>
      <Heading fontWeight={100} mb={"3"} maxWidth="1000px" width="100%" textAlign="center">
        The{" "}
        <Select
          variant="outline"
          maxWidth="90px"
          width="100%"
          size="lg"
          fontSize="2xl"
          display="inline-block"
          fontWeight="bold"
          icon=""
          textAlign="center"
          justifyContent="center"
          style={{ textAlignLast: "center" }} // needed in chrome
          value={period}
          cursor="pointer"
          onChange={(e) => setPeriod(e.currentTarget.value)}
        >
          <option value="day">day</option>
          <option value="month">month</option>
          <option value="year">year</option>
        </Select>{" "}
        you watched the{" "}
        <Select
          variant="outline"
          maxWidth="75px"
          width="100%"
          size="lg"
          fontSize="2xl"
          display="inline-block"
          fontWeight="bold"
          textAlign="center"
          style={{ textAlignLast: "center" }}
          icon=""
          cursor="pointer"
          value={adjective}
          onChange={(e) => setAdjective(e.currentTarget.value)}
        >
          <option value="most">most</option>
          <option value="least">least</option>
        </Select>{" "}
        Videos was{" "}
        <Text fontWeight="bold" display="inline">
          {date}:
        </Text>
      </Heading>
      {renderPhrase()}
    </>
  );
}

export default Header;
